/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SkillVersion = {
  /**
   * Unique identifier for the version
   */
  id: string;
  /**
   * Unix timestamp when the version was created
   */
  createdAt: number;
  /**
   * Description of the skill version
   */
  description: string;
  /**
   * Name of the skill version
   */
  name: string;
  object?: "skill.version" | undefined;
  /**
   * Parent skill identifier
   */
  skillId: string;
  /**
   * Version number
   */
  version: string;
};

/** @internal */
export const SkillVersion$inboundSchema: z.ZodType<
  SkillVersion,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  created_at: z.number().int(),
  description: z.string(),
  name: z.string(),
  object: z.literal("skill.version").default("skill.version"),
  skill_id: z.string(),
  version: z.string(),
}).transform((v) => {
  return remap$(v, {
    "created_at": "createdAt",
    "skill_id": "skillId",
  });
});
/** @internal */
export type SkillVersion$Outbound = {
  id: string;
  created_at: number;
  description: string;
  name: string;
  object: "skill.version";
  skill_id: string;
  version: string;
};

/** @internal */
export const SkillVersion$outboundSchema: z.ZodType<
  SkillVersion$Outbound,
  z.ZodTypeDef,
  SkillVersion
> = z.object({
  id: z.string(),
  createdAt: z.number().int(),
  description: z.string(),
  name: z.string(),
  object: z.literal("skill.version").default("skill.version" as const),
  skillId: z.string(),
  version: z.string(),
}).transform((v) => {
  return remap$(v, {
    createdAt: "created_at",
    skillId: "skill_id",
  });
});

export function skillVersionToJSON(skillVersion: SkillVersion): string {
  return JSON.stringify(SkillVersion$outboundSchema.parse(skillVersion));
}
export function skillVersionFromJSON(
  jsonString: string,
): SafeParseResult<SkillVersion, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillVersion$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillVersion' from JSON`,
  );
}
